<div class="PGAdminRealmUsers">
    <div class="PGAdminRealmUsers-Head">
        <div>
            <h4>{{ 'pg-admin-realm-users.title' | locTranslate }}: {{realmName}}</h4>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]="searchValue" (change)="loadData()"/>
                    <div class="input-group-text {{ appliedSearchValue ? 'bg-primary text-white' : '' }}">
                        <i class="fa-regular fa-search"></i>
                    </div>
                </div>
            </div>
            @if (getRealmFilter() != null) {
                @if (resourceMode == 'admin') {
                    <div class="d-flex align-items-center">
                        <app-pg-select resource="User" [resourceMode]="resourceMode" [resourceSemantic]="userResourceSemantic" [(ngModel)]="addUser" display="oneLine"></app-pg-select>
                        <button class="btn btn-primary ms-2" (click)="doAddUser()" [disabled]="!addUser">
                            <i class="fa-regular fa-user-plus"></i>
                        </button>
                    </div>
                }
                @else {
                    <div ngbDropdown>
                        <button ngbDropdownToggle class="btn btn-white" #copyClipboardTooltip="ngbTooltip" ngbTooltip="{{ 'pg-copy-clipboard.copied' | locTranslate }}" triggers="manual">
                            <span class="me-2">{{ 'pg-admin-realm-users.actions' | locTranslate }}</span>
                            <i class="fa-regular fa-ellipsis-v"></i>
                        </button>
                        <div ngbDropdownMenu>
                            <div class="dropdown-item" (click)="sendInviteEmailOpen()">
                                <i class="fa-regular fa-envelope"></i>
                                <span>{{ 'pg-admin-realm-users.invite-email' | locTranslate }}</span>
                            </div>

                            <div class="dropdown-divider"></div>
        
                            <div class="dropdown-item-text">
                                <b>{{ 'pg-admin-realm-users.invite-link' | locTranslate }}</b>
                            </div>

                            <!--@for(application of ['Forms','Entourance']; track application) {-->
                            <!-- NB: rimosso entourance perché richiederebbe un accesso editor ed è un buco di sicurezza -->
                            @for(application of ['Forms']; track application) {
                                <app-pg-copy-clipboard [text]="getApplicationInviteLink(application)" [noTooltip]="true" (click)="showCopyClipboardTooltip()">
                                    <div class="dropdown-item">
                                        <div>{{ 'pg-admin-realm-users.invite-link-' + application.toLowerCase() | locTranslate }}</div>
                                        <div class="small text-muted">{{ 'pg-admin-realm-users.invite-link-tooltip-' + application.toLowerCase() | locTranslate }}</div>
                                    </div>
                                </app-pg-copy-clipboard>
                            }

                            <div class="dropdown-divider"></div>

                            <div class="dropdown-item" (click)="sendMessageOpen()">
                                <i class="fa-regular fa-message"></i>
                                <span>{{ 'pg-admin-realm-users.send-message' | locTranslate }}</span>
                            </div>

                            <div class="dropdown-item" (click)="exportUsers()">
                                <i class="fa-regular fa-file-csv"></i>
                                <span>{{ 'pg-admin-realm-users.export-users' | locTranslate }}</span>
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
    </div>

    <hr>

    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @else {
        @if (resourceMode == 'admin' || getRealmFilter() == null) {
            @for (userRealm of userRealmData; track userRealm) {
                <ng-container *ngTemplateOutlet="userRealmDataTemplate;context:{ userRealm: userRealm }"></ng-container>
            }
            @if (isLoadingUsers) {
                <app-pg-loading></app-pg-loading>
            }
            <app-pg-view-more [hidden]="atEnd || isLoadingUsers" (viewMore)="loadMoreData()"></app-pg-view-more>
        }
        @else {
            <div class="accordion pb-1">
                @for(item of usersWithRole | keyvalue; track item) {
                    <div class="accordion-item">                    
                        <h4 class="accordion-header">
                            <button class="accordion-button {{userSectionsExpanded['role-' + item.key] ? '' : 'collapsed'}}" (click)="userSectionsExpanded['role-' + item.key] = !userSectionsExpanded['role-' + item.key]">
                                <i class="fa-regular {{ getRoleIcon(item.key) }} me-2 fa-fw"></i><span>{{ 'pg-admin-realm-users.users-role-' + item.key | locTranslate }}</span>
                            </button>
                        </h4>
                
                        <div class="accordion-collapse collapse {{userSectionsExpanded['role-' + item.key] ? 'show' : ''}}">
                            <div class="accordion-body pg-animation-slidedown">
                                @for (userRealm of item.value; track userRealm) {
                                    <ng-container *ngTemplateOutlet="userRealmDataTemplate;context:{ userRealm: userRealm }"></ng-container>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="accordion-item">                    
                    <h4 class="accordion-header">
                        <button class="accordion-button {{userSectionsExpanded.noRoles ? '' : 'collapsed'}}" (click)="userSectionsExpanded.noRoles = !userSectionsExpanded.noRoles">
                            <i class="fa-regular fa-user me-2 fa-fw"></i><span>{{ 'pg-admin-realm-users.users-no-roles' | locTranslate }}</span>
                        </button>
                    </h4>
            
                    <div class="accordion-collapse collapse {{userSectionsExpanded.noRoles ? 'show' : ''}}">
                        <div class="accordion-body pg-animation-slidedown">
                            @if(atEnd && userRealmData.length == 0) {
                                <h5 class="m-0 text-muted">{{ 'pg-admin-realm-users.no-users' | locTranslate }}</h5>
                            }
                            @for (userRealm of userRealmData; track userRealm) {
                                <ng-container *ngTemplateOutlet="userRealmDataTemplate;context:{ userRealm: userRealm }"></ng-container>
                            }
                            @if(isLoadingUsers) {
                                <app-pg-loading></app-pg-loading>
                            }
                            <app-pg-view-more [hidden]="atEnd || isLoadingUsers || !userSectionsExpanded.noRoles" (viewMore)="loadMoreData()"></app-pg-view-more>
                        </div>
                    </div>
                </div>

                <div class="accordion-item">                    
                    <h4 class="accordion-header">
                        <button class="accordion-button {{userSectionsExpanded.rejected ? '' : 'collapsed'}}" (click)="userSectionsExpanded.rejected = !userSectionsExpanded.rejected">
                            <i class="fa-regular fa-times me-2 fa-fw"></i><span>{{ 'pg-admin-realm-users.users-rejected' | locTranslate }}</span>
                        </button>
                    </h4>
            
                    <div class="accordion-collapse collapse {{userSectionsExpanded.rejected ? 'show' : ''}}">
                        <div class="accordion-body pg-animation-slidedown">
                            @for (userRealm of userRejected; track userRealm) {
                                <ng-container *ngTemplateOutlet="userRealmDataTemplate;context:{ userRealm: userRealm }"></ng-container>
                            }
                            @if (isLoadingRejected) {
                                <app-pg-loading></app-pg-loading>
                            }
                            <app-pg-view-more [hidden]="atEndRejected || isLoadingRejected || !userSectionsExpanded.rejected" (viewMore)="loadMoreDataRejected()"></app-pg-view-more>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
</div>

<ng-template #userRealmDataTemplate let-userRealm="userRealm">
    <div class="PGAdminRealmUsers-Item align-items-center border-top mt-3 pt-3">
        <div class="d-flex justify-content-between">
            @if (userRealm.related_user; as user) {
                <div class="PGAdminRealmUsers-Item-Inner">
                    <div class="d-flex align-items-start justify-content-between">
                        <div class="PGAdminRealmUsers-Item-User">
                            <app-pg-user [user]="user" [profile]="userRealm.related_profile"></app-pg-user>
                        </div>
                        @if (resourceMode != 'admin') {
                            <div class="PGAdminRealmUsers-Item-Search">
                                <button class="btn btn-link py-0" (click)="searchUserBusinessOpen(user)">
                                    <span>{{ 'pg-admin-realm-users.search-business' | locTranslate }}</span>
                                    <i class="fa-regular fa-address-book"></i>
                                </button>
                            </div>
                        }
                    </div>
                    
                    <div class="PGAdminRealmUsers-Item-Roles mt-3">
                        <label class="pb-2">
                            <b>ROLES</b>
                        </label>
                        <app-pg-resource-association resourceId="Role" relatedResource="User" [relatedElement]="user.id" [relationConfig]="roleUserRelationConfig" [resourceSemantic]="idNameSemantic" [resourceMode]="resourceMode" [realmFilter]="getRealmFilter()" [resourceData]="userRealm.related_user.related_role" [ignoreValuesList]="rolesIgnoreValuesList"></app-pg-resource-association>
                    </div>
                </div>
            }
            @if (getRealmFilter() != null) {
                <div class="PGAdminRealmUsers-Item-Buttons border-start ps-2 ms-2 d-flex flex-column align-items-center justify-content-{{resourceMode == 'admin' ? 'between' : 'center'}}">
                    <div>
                        @if(userRealm.status == 'invited') {
                            <div class="text-muted">
                                <i class="fa-regular fa-envelope me-2"></i>
                                <span>{{ 'pg-admin-realm-users.invited' | locTranslate }}</span>
                            </div>
                        }
                        @else {
                            <button class="btn btn-sm btn-{{userRealm.status == 'rejected' ? 'danger' : 'secondary'}}" [disabled]="isSavingUserRealm[userRealm.id] || userRealm.status == 'rejected'" (click)="setUserRealmStatus(userRealm, 'rejected')">
                                <i class="fa-regular fa-times"></i>
                                <span>{{ 'pg-admin-realm-users.rejected' | locTranslate }}</span>
                            </button>
                            <button class="ms-2 btn btn-sm btn-{{userRealm.status == 'accepted' ? 'success' : 'secondary'}}" [disabled]="isSavingUserRealm[userRealm.id] || userRealm.status == 'accepted'" (click)="setUserRealmStatus(userRealm, 'accepted')">
                                <i class="fa-regular fa-check"></i>
                                <span>{{ 'pg-admin-realm-users.accepted' | locTranslate }}</span>
                            </button>
                        }
                    </div>
                    @if(resourceMode == 'admin') {
                        <div class="pt-3">
                            <app-pg-confirm-action [disabled]="isSavingUserRealm[userRealm.id]" (confirmed)="deleteUserRealm(userRealm)">
                                <button class="btn btn-sm btn-link text-danger p-0">
                                    <span>{{ 'pg-admin-realm-users.delete' | locTranslate }}</span>
                                </button>
                            </app-pg-confirm-action>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</ng-template>

<ng-template #searchBusinessModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-admin-realm-users.search-business-title' | locTranslate:'user':getUserLabel(searchUserBusinessTarget) }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="searchUserBusinessDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body PGAdminRealmUsers-SearchUserBusiness-Body">
        @if (searchUserBusinessLoading || searchUserBusinessIsSaving) {
            <app-pg-loading [isOverlay]="searchUserBusinessIsSaving"></app-pg-loading>
        }
        @if (!searchUserBusinessLoading) {
            @if (searchUserBusinessHasNoData()) {
                <h4 class="text-muted text-center m-0">{{ 'pg-admin-realm-users.search-business-no-data' | locTranslate }}</h4>
            }
            @if (!searchUserBusinessHasNoData()) {
                <table class="table text-nowrap">
                    <thead>
                        <tr>
                            <th class="bg-light">{{ 'pg-admin-realm-users.search-business-col-company' | locTranslate }}</th>
                            @if (searchUserBusinessTarget.email) {
                                <th class="bg-light">{{ 'pg-admin-realm-users.search-business-col-email' | locTranslate }}</th>
                            }
                            @if (searchUserBusinessTarget.telephone) {
                                <th class="bg-light">{{ 'pg-admin-realm-users.search-business-col-phone' | locTranslate }}</th>
                            }
                            <th class="bg-light">{{ 'pg-admin-realm-users.search-business-col-user' | locTranslate }}</th>
                            <th class="bg-light"></th>
                        </tr>
                    </thead>
                    @for (item of searchUserBusinessData | keyvalue; track item) {
                        @if (item.value.length > 0) {
                            <tbody>
                                <tr>
                                    <td [attr.colspan]="(3 + (searchUserBusinessTarget.email ? 1 : 0) + (searchUserBusinessTarget.telephone ? 1 : 0))">
                                        <h5 class="m-0">{{ 'RESOURCES.' + item.key + '.name' | locTranslate }}</h5>
                                    </td>
                                </tr>
                                @for (element of item.value; track element) {
                                    <tr>
                                        <td>{{element.id}} - {{element.name}}</td>
                                        @if (searchUserBusinessTarget.email) {
                                            <td>{{ element.email }}</td>
                                        }
                                        @if (searchUserBusinessTarget.telephone) {
                                            <td>{{ element.telephone }}</td>
                                        }
                                        <td>
                                            @if (element.user) {
                                                {{ getUserLabel(element.user) }}
                                            }
                                        </td>
                                        <td class="p-0">
                                            @if (element.user_id != searchUserBusinessTarget.id) {
                                                <button class="btn btn-link" (click)="searchUserBusinessSetUser(item.key, element)">
                                                    <i class="fa-regular fa-user"></i>
                                                    <span>{{ 'pg-admin-realm-users.search-business-button-set-user' | locTranslate }}</span>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        }
                    }
                </table>
            }
        }
    </div>
</ng-template>

<ng-template #sendInviteEmailModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-admin-realm-users.send-email-invite-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="sendInviteEmailDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body PGAdminRealmUsers-SendEmailInvite-Body">
        <div>
            <div class="form-group">
                <label><b>{{ 'pg-admin-realm-users.send-email-invite-recipient' | locTranslate }}</b></label>
                <app-pg-select [options]="sendInviteRoleOptions" [(ngModel)]="sendInviteRoleValue" [required]="true"></app-pg-select>
            </div>
        </div>
        <div class="d-flex">
            <div class="form-group m-0">
                <label><b>{{ 'pg-admin-realm-users.send-email-invite-address' | locTranslate }}</b></label>
                <app-pg-email [(ngModel)]="sendInviteEmailAddress"></app-pg-email>
            </div>
            <div>
                <button class="btn btn-primary ms-2" [disabled]="isSubmittingSendInviteEmail || !canSubmitSendInviteEmail()" (click)="doSubmitSendInviteEmail()">
                    <i class="fa-regular fa-send"></i>
                    <span>{{ 'pg-admin-realm-users.send-email-invite-button' | locTranslate }}</span>
                </button>
            </div>
        </div>
        @if(submitSendInviteEmailError) {
            <div class="mt-1">
                <span class="form-text text-danger">{{ 'pg-admin-realm-users.send-email-invite-error' | locTranslate }}</span>
            </div>
        }

        <hr/>
        <div>
            <div class="form-group">
                <label><b>{{ 'pg-admin-realm-users.send-email-pending-invites' | locTranslate }}</b></label>
                
                @if(isLoadingPendingInvites) {
                    <app-pg-loading></app-pg-loading>
                }
                @else {
                    <div>
                        @if(sendInvitePendingInvites.length == 0) {
                            {{ 'pg-admin-realm-users.send-email-pending-invites-none' | locTranslate }}
                        }

                        @for(invite of sendInvitePendingInvites; track invite) {
                            <app-pg-user [user]="invite.related_user" [small]="true"></app-pg-user>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</ng-template>

<ng-template #sendMessageModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-admin-realm-users.send-message-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="sendMessageDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body PGAdminRealmUsers-SendMessage-Body">
        <div class="form-group">
            <label for="PGAdminRealmUsers-SendMessage-Body-Subject"><b>{{ 'pg-admin-realm-users.send-message-subject' | locTranslate }}</b></label>
            <input id="PGAdminRealmUsers-SendMessage-Body-Subject" class="form-control" [(ngModel)]="sendMessageSubject"/>
        </div>
        <div class="form-group">
            <label for="PGAdminRealmUsers-SendMessage-Body-Content"><b>{{ 'pg-admin-realm-users.send-message-content' | locTranslate }}</b></label>
            <textarea id="PGAdminRealmUsers-SendMessage-Body-Content" class="form-control" [(ngModel)]="sendMessageContent"></textarea>
        </div>

        <div>
            <button class="btn btn-primary ms-2" [disabled]="isSubmittingSendMessage || !canSubmitSendMessage()" (click)="doSubmitSendMessage()">
                <i class="fa-regular fa-send"></i>
                <span>{{ 'pg-admin-realm-users.send-message-button' | locTranslate }}</span>
            </button>
        </div>

        @if(submitSendMessageError) {
            <div class="mt-1">
                <span class="form-text text-danger">{{ 'pg-admin-realm-users.send-message-error' | locTranslate }}</span>
            </div>
        }
    </div>
</ng-template>